import { Components, Theme } from '@mui/material';
import { fontFamily } from './typography';

export const buildMuiTextFieldComponent = (): Components<Omit<Theme, 'components'>>['MuiTextField'] => ({
  styleOverrides: {
    root: {
      fontFamily,
    },
  },
  defaultProps: {
    InputLabelProps: {
      shrink: true,
    },
    margin: 'normal',
    fullWidth: true,
  },
});

export const buildMuiInputLabelComponent = (): Components<Omit<Theme, 'components'>>['MuiInputLabel'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily,
      '&, &.Mui-error, &.Mui-focused': {
        position: 'static',
        transform: 'none',
        transition: 'none',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '200%',
        textTransform: 'uppercase',
        color: theme.palette.primary[60],
        marginBottom: '8px',
      },
    }),
    sizeSmall: {
      '&, &.Mui-error, &.Mui-focused': {
        fontSize: '11px',
      },
    },
  },
  defaultProps: {
    shrink: true,
  },
});

export const buildMuiInputBaseComponent = (): Components<Omit<Theme, 'components'>>['MuiInputBase'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily,
      height: '44px',
      color: theme.palette.primary.main,
      'label + &.MuiInput-underline': {
        marginTop: 0,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.primary[10],
      },
      '&.MuiInputAdornment-root': {
        color: theme.palette.primary[80],
      },
      '&.Mui-focused .MuiInputAdornment-root': {
        color: theme.palette.primary.main,
      },
      '&.Mui-disabled .MuiInputAdornment-root': {
        color: theme.palette.primary[40],
      },
      '& .MuiInputBase-input': {
        padding: '10px',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '150%',
        color: theme.palette.primary.main,
      },
      '& .MuiInputBase-input::placeholder': {
        opacity: 1,
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '150%',
        color: theme.palette.primary[60],
      },
      '&.Mui-focused .MuiInputBase-input::placeholder': {
        opacity: 0,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.primary[50] ?? theme.palette.primary.light}`,
        borderRadius: '4px',
        padding: '10px',
        margin: 0,
        top: 0,
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary[40],
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px!important',
      },
      '& .MuiOutlinedInput-notchedOutline > legend': {
        display: 'none',
      },
      '&.MuiInputBase-multiline': {
        height: '100%',
        minHeight: '44px',
        padding: 0,
      },
      '&&.Mui-readOnly': {
        '& .MuiInputBase-input': {
          color: theme.palette.primary[70],
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary[50],
        },
      },
    }),
    sizeSmall: {
      height: '31px',
      '& .MuiInputBase-input': {
        fontSize: '12px',
      },
      '& .MuiInputBase-input::placeholder': {
        fontSize: '12px',
      },
      '& .MuiInputAdornment-root .MuiSvgIcon-root': {
        fontSize: '1rem',
      },
      '&.MuiInputBase-multiline': {
        minHeight: '31px',
      },
    },
  },
});
